<template>
  <div class="main">
    <h2>{{ $t('product.bestSeller') }}</h2>
    <div class="productList">
      <div v-for="item in products" class="product" :key="item.id">
        <div class="topPart">
          <div class="themeTitle textline1 fontPB">
            {{ item.category_name }}
          </div>
          <div @click.stop="goDetail(item.id)">
            <el-image
              class="productImg"
              :src="item.image_url"
              fit="contain"
            ></el-image>
          </div>
        </div>
        <div class="name fontPR textline1">{{ item.title }}</div>
        <div class="price fontPB">
          <span :class="item.sales_price && item.sales ? 'priceline' : ''">
            {{ $store.state.ccode }} {{ item.price }}
          </span>
          <span v-if="item.sales_price && item.sales">
            {{ $store.state.ccode }} {{ item.sales_price }}
          </span>
        </div>
        <!-- <el-button type="primary" round style="margin:0 auto">{{ $t("product.addcart") }}</el-button> -->
        <div class="buy">
          <button @click="addCart(item.id)">{{ $t('product.addcart') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['products', 'title'],
  data () {
    return {};
  },
  methods: {
    goDetail (id) {
      this.$router.push('/ProductDetail/' + id);
      // this.$router.push('/ProductDetail/'+89);

    },
    addCart (id) {
      this.$axios({
        method: 'GET',
        url: '/api/products/' + id,
        headers: {
          Authorization:
            this.$localStorage.token_type + this.$localStorage.token,
        },
      }).then((res) => {
        if (res.sku.length) {
          this.selPro = { ...res.sku[0], shop_product: res, amount: 1 };
          this.$store.commit('addToCart', this.selPro);
        } else {
          console.log('sku为空');
        }
      });
    },
  },
};
</script>

<style scoped>
.main {
  padding : 0 0 30px 0;
}

.main h2 {
  padding          : 30px;
  background-color : #92d1e1;
  color            : white;
}

.buy {
  text-align : center;
}

.productList {
  display         : flex;
  justify-content : space-around;
  flex-wrap       : wrap;
  padding         : 0 50px;
}

.product {
  width       : 22%;
  /* width: 30%; */
  margin      : 20px 0;
  margin-left : 2.5%;
  /* box-shadow: 5px 5px 5px #E8E8E8; */
}

.productImg {
  height : 250px;
}

.topPart {
  width            : 100%;
  background-color : #fff;
  border-radius    : 10px;
  border           : 1px solid #e8e8e8;
  box-shadow       : 5px 5px 5px #e8e8e8;
  position         : relative;
}

.addCartBtn {
  height        : auto;
  width         : 100%;
  text-align    : center;
  margin-bottom : 8px;
}

.addCartBtn i {
  font-size : 40px;
  color     : #ffc80b;
}

.themeTitle {
  width       : 90%;
  height      : 40px;
  line-height : 40px;
  margin      : auto;
  font-size   : 17px;
  color       : #707070;
}

.name {
  width        : 100%;
  line-height  : 35px;
  color        : #4a4a4a;
  font-size    : 14px;
  padding-left : 10px;
}

.price {
  width        : 100%;
  line-height  : 20px;
  padding-left : 10px;
  color        : #4a4a4a;
  font-size    : 14px;
}

.priceline {
  text-decoration : line-through;
  margin-right    : 5px;
  color           : #bababa;
}

.detailBox {
  width      : 84%;
  margin     : 0 auto;
  min-height : 500px;
  position   : relative;
  color      : #7b5c55;
}

.el-image {
  width : 100%;
}

.boxTitle {
  position  : absolute;
  font-size : 24px;
  top       : 0;
  left      : 0;
}

.des {
  width       : 100%;
  min-height  : 30px;
  line-height : 30px;
  font-size   : 20px;
  margin-top  : 10px;
}

.btns {
  width      : 100%;
  min-height : 50px;
}

.btns > div {
  width   : 49%;
  display : inline-block;
}

.priceTk {
  line-height : 50px;
  font-size   : 20px;
}

.buy > button {
  width            : 45%;
  height           : 50px;
  line-height      : 50px;
  color            : #fff;
  background-color : #FFC80B;
  border-radius    : 25px;
  border           : 0;
  outline          : 0;
  font-size        : 24px;
  margin-top       : 20px;
  border           : none;
  outline          : none;
}

.sortList {
  width     : 100%;
  font-size : 16px;
}

/*手机*/
@media screen and (max-width : 767px) {
  .product {
    width  : 41%;
    margin : 10px 10px;
  }

  .productList {
    padding : 0;
  }

  .productImg {
    height : 100px;
  }

  .buy > button {
    /* width: 45%; */
    height      : 40px;
    line-height : 40px;
    font-size   : 16px;
  }

  .themeTitle {
    font-size : 14px;
  }
}

/*平板*/
@media screen and (min-width : 768px) and (max-width : 992px) {
  .product {
    width  : 42%;
    margin : 10px 30px;
  }

  .productList {
    padding : 0;
  }

  .productImg {
    height : 200px;
  }

  .buy > button {
    /* width: 45%; */
    height      : 40px;
    line-height : 30px;
    font-size   : 20px;
  }

  .themeTitle {
    font-size : 20px;
  }
}

/*中等屏幕*/
@media screen and (min-width : 992px) and (max-width : 1200px) {
  .shopContent {
    width  : 90%;
    margin : auto;
  }

  .productImg {
    height : 160px;
  }
}

/*大屏幕*/
@media screen and (min-width : 1200px) {
  .shopContent {
    width     : 90%;
    max-width : 1200px;
    margin    : auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/ProductList.vue